import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "Util/getCustomColor";

const styles = makeStyles(() => ({
  peopleWrapper: {
    padding: "24px 24px 0 24px",
  },
  peopleHeader: {
    marginBottom: 24,
  },
  peopleHeaderBreadcrumb: {
    "& ol": {
      alignItems: "flex-end",
    },
  },
  peopleHeaderBreadcrumbTitle: {
    fontSize: 18,
    lineHeight: "24px",
    fontWeight: "bold",
    color: getBrandCustom("primaryColor", "#38cfc4"),
    fontFamily: `'Manrope', sans-serif`,
    "&.active": {
      color: "#465869",
    },
    "&.linkToPeopleTab": {
      cursor: "pointer",
    },
  },
}));

export default styles;
